export default __webpack_public_path__ + "static/media/figmafront.3e3c88b7.svg";